<template>
  <div>
    <TitleWithButton
      title="Параметры"
      button-text="Добавить"
      creatable
      class="mt-6 mb-4 headline"
      @create="onCreateClick"
    />

    <BTableCommon
      :list="list"
      :items-per-page-options="itemsPerPageOptions"
      :loading="isLoading"
      type="base-event-parameters"
      @action:view="onView"
      @action:edit="onEdit"
      @action:delete="onDelete"
    />
  </div>
</template>

<script>
import { DEFAULT_PER_PAGE_OPTIONS } from '@/helpers/enums/params'
import { createBaseEventParameterModal } from './utils'
import { RoadmapExpertsParametersApi } from '@/api/resources/Admin/Roadmap/Experts/Parameters'

import BTableCommon from '@/components/tables/BTableCommon.vue'
import TitleWithButton from '@/components/common/TitleWithButton.vue'

export default {
  name: 'BaseEventParameterList',
  components: {
    BTableCommon,
    TitleWithButton,
  },
  props: {
    criterionId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      itemsPerPageOptions: [5, ...DEFAULT_PER_PAGE_OPTIONS],
      list: [],
    }
  },
  methods: {
    async asyncData() {
      this.api = new RoadmapExpertsParametersApi()
      await this.onGetData()
    },
    async onGetData() {
      this.isLoading = true
      try {
        const { data } = await this.api.getAll({ criterion_id: this.criterionId })
        this.list = data
      } catch (e) {
        this.$notice.errors(e)
      }
      this.isLoading = false
    },
    async onCreateClick() {
      const modal = await createBaseEventParameterModal(this, {
        criterionId: this.criterionId,
        on: {
          created: this.onGetData,
        },
      })
      await modal.open()
    },
    async onEdit(item, callback) {
      const unwatch = callback?.()

      try {
        const { data } = await this.api.getOne(item.id)
        const modal = await createBaseEventParameterModal(this, {
          criterionId: this.criterionId,
          parameter: data,
          viewOnly: false,
          on: {
            created: this.onGetData,
          },
        })
        modal.open()
      } catch (e) {
        this.$notice.errors(e)
      }

      unwatch?.()
    },
    async onView(item, callback) {
      const unwatch = callback?.()

      try {
        const { data } = await this.api.getOne(item.id)
        const modal = await createBaseEventParameterModal(this, {
          criterionId: this.criterionId,
          parameter: data,
          viewOnly: true,
        })
        modal.open()
      } catch (e) {
        this.$notice.errors(e)
      }

      unwatch?.()
    },
    async onDelete(data, cb) {
      const unwatch = cb?.()

      try {
        await this.api.delete(data.id)
        this.list = this.list.filter((_) => _.id !== data.id)
      } catch (e) {
        this.$notice.errors(e)
      }

      unwatch?.()
    },
  },
}
</script>
